import { render, staticRenderFns } from "./expert-team-video.vue?vue&type=template&id=ea28ac6c&scoped=true&"
import script from "./expert-team-video.vue?vue&type=script&lang=js&"
export * from "./expert-team-video.vue?vue&type=script&lang=js&"
import style0 from "./expert-team-video.vue?vue&type=style&index=0&id=ea28ac6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea28ac6c",
  null
  
)

export default component.exports